import { Asterisk } from "@phosphor-icons/react";
import { MARQUEE_ITEMS } from "@/data/site";
import { useCategories } from "@/lib/categoriesStore";

export const Marquee = () => {
  const { categories, fromApi } = useCategories();
  const base = fromApi ? categories.map((c) => c.nombre) : MARQUEE_ITEMS;
  const source = base.length > 0 ? base : MARQUEE_ITEMS;
  const items = [...source, ...source, ...source, ...source];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-black/10 bg-white py-6 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee-slow items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span
                  className={`font-display uppercase font-semibold text-5xl sm:text-6xl lg:text-7xl tracking-tight px-6 ${
                    i % 2 === 0 ? "text-outline" : "text-black/85"
                  }`}
                >
                  {item}
                </span>
                <Asterisk size={40} weight="bold" className="text-[#FF5508] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
